module.exports = __webpack_public_path__ + "static/media/trashIcon.2bd8d852.png";